import React, { RefObject, useCallback, memo } from 'react';

interface EmailInputProps {
  onEmailChange?: (email: string) => void;
  initialValue?: string;
  value?: string;
  onChange?: (email: string) => void;
  inputRef?: RefObject<HTMLInputElement>;
  placeholder?: string;
  autoComplete?: string;
}

const EmailInput: React.FC<EmailInputProps> = ({ 
  onEmailChange, 
  initialValue = '', 
  value, 
  onChange,
  inputRef,
  placeholder = 'Enter your email',
  autoComplete = 'off'
}) => {
  // Handle input changes - use useCallback to prevent recreating this function on every render
  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    // Support both old and new API
    if (onEmailChange) onEmailChange(e.target.value);
    if (onChange) onChange(e.target.value);
  }, [onEmailChange, onChange]);

  // Determine if we're using controlled or uncontrolled component
  const isControlled = value !== undefined;

  return (
    <div 
      style={{ 
        position: 'relative', 
        zIndex: 9999,
        width: '100%'
      }}
    >
      <input
        ref={inputRef}
        type="email"
        id="email-input"
        name="email-no-autofill"
        value={isControlled ? value : undefined}
        defaultValue={!isControlled ? initialValue : undefined}
        onChange={handleChange}
        placeholder={placeholder}
        required
        autoComplete={autoComplete}
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
        data-form-type="other"
        data-lpignore="true"
        autoFocus
        style={{ 
          width: '100%',
          padding: '12px 15px',
          border: '1px solid #ddd',
          borderRadius: '4px',
          fontSize: '16px',
          backgroundColor: '#fff',
          position: 'relative',
          zIndex: 9999
        }}
      />
    </div>
  );
};

// Use memo to prevent unnecessary rerenders
export default memo(EmailInput); 